window.$ = window.jQuery = require('jquery'); // 91.6 Kib
require('./lightbox'); // 6.6 Kib (98.2 Kib)
require('./carousel'); // 42.8 Kib (141 Kib)
require('./network'); // 109 Kib (250 Kib)
require('./inscription_questionnaire'); // 1 Kib (251 Kib)
require('./upload'); // 19 Kib (270 Kib)
require('./notification'); // 5 Kib (275 Kib)


document.addEventListener("DOMContentLoaded", function() {
    window.loadFunction();
});
document.addEventListener("turbolinks:load", function() {
    window.loadFunction();
})

window.loadFunction = () => {

    //dropdown

    if (document.querySelector('.js-dropdown'))
    {
        document.querySelector('.js-dropdown').addEventListener('click', function (e) {
            e.stopPropagation();
            this.classList.toggle('is-open');
        });
    }

    if (document.querySelector('body'))
    {
        document.querySelector('body').addEventListener('click', function () {
            if (document.querySelector('.js-dropdown')) {
                document.querySelector('.js-dropdown').classList.remove("is-open");
            }
        });
    }

    //off canvas search, action messagerie

    const menuRevealBtn = document.querySelector('#search');
    const sideNav = document.querySelector('#side-nav');
    const sideNavMask = document.querySelector('#side-nav-mask');
    const actionMessage = document.querySelector('#actionMessage');
    const sideAction = document.querySelector('#sideAction');
    const actionPhoto = document.querySelector('#listPhotoOther');
    const sidePhoto = document.querySelector('#sidePhoto');


    if (menuRevealBtn) {
        menuRevealBtn.addEventListener('click', function () {
            sideNav.classList.add('visible');
            sideNavMask.classList.add('visible');
        });
    }

    if (actionMessage) {
        actionMessage.addEventListener('click', function () {
            sideAction.classList.add('visible');
            sideNavMask.classList.add('visible');
        });
    }

    if (actionPhoto) {
        actionPhoto.addEventListener('click', function (e) {
            if(e.target.parentElement.classList.contains('actionPhoto')) {
                document.querySelector('#croppr').setAttribute(
                    'src',
                    e.target.parentElement.getAttribute('data-src') + '?t=' + Math.round(new Date().getTime() / 1000)
                );
                document.querySelector('#current-photo-profil-src-modal').setAttribute('value',e.target.parentElement.getAttribute('data-src'));
                document.querySelector('#current-photo-profil-modal').setAttribute('value',e.target.parentElement.getAttribute('data-id'));
                sidePhoto.classList.add('visible');
                sideNavMask.classList.add('visible');
            }
        });
    }


    sideNavMask.addEventListener('click', function () {
        if (actionMessage) {
            sideAction.classList.remove('visible');
        }

        if (actionPhoto) {
            sidePhoto.classList.remove('visible');
        }

        sideNav.classList.remove('visible');
        sideNavMask.classList.remove('visible');
    });

    //mask unmask input password

    let btnMask = document.querySelectorAll('.input-password-mask');

    for (let i = 0; i < btnMask.length; i++) {
        btnMask[i].addEventListener('click', function () {
            togglePasswordMask(this);
        });
    }

    function togglePasswordMask(maskToggleIcon) {
        let inputWrapper = maskToggleIcon.parentNode;
        inputPass = inputWrapper.lastElementChild;

        if (inputWrapper.classList.contains('password-unmasked')) {
            inputPass.setAttribute('type', 'password');
            inputWrapper.classList.remove('password-unmasked');
        } else {
            inputPass.setAttribute('type', 'text');
            inputWrapper.classList.add('password-unmasked');
        }
    }

    //modal

    const modalBtns = [...document.querySelectorAll(".modal-toggle")];
    modalBtns.forEach(function (btn) {
        btn.onclick = function () {
            var modal = btn.getAttribute('data-modal');
            document.getElementById(modal).style.display = "block";
        };
    });

    const closeBtns = [...document.querySelectorAll(".modal-close")];
    closeBtns.forEach(function (btn) {
        btn.onclick = function () {
            var modal = btn.closest('.modal');
            modal.style.display = "none";
        };
    });

    window.onclick = function (event) {
        if (event.target.className === "modal") {
            event.target.style.display = "none";
        }
    };

    //coach

    const clicCoach = document.querySelector(".coach-clic");
    const coachSide = document.querySelector(".coach-side");

    if (clicCoach){
        clicCoach.addEventListener('click', function () {
            coachSide.classList.toggle('active');
        });
    }

    //btn-sticky

    window.onscroll = function() {
        if(pastorAction) {
            btnSticky();
        }

    };

    let pastorAction = document.getElementById("pastor-action");

    function btnSticky() {
        let sticky = pastorAction.offsetTop;
        if (window.pageYOffset >= sticky) {
            pastorAction.classList.add("sticky")
        } else {
            pastorAction.classList.remove("sticky");
        }
    }


};


//JQUERY
$(document).ready(function () {


    //tabs

    $('.tabs li').click(function () {
        var tab_id = $(this).attr('data-tab');

        $('.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#" + tab_id).addClass('current');

    });

    //scroll

    $('#help-nav').on('click', '.link', function(e){
        e.stopPropagation();
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $("#" + $(this).attr('data-section') ).position().top - 200
        }, 500);
        return false;

    });

    //active photo account

    $('.photo-other .photo div').click(function () {
        $('.photo-other .photo div').removeClass("active");
        $(this).addClass("active");
    });

    //scrollTop

    var scrollTop = $(".scrollTop");

    $(window).scroll(function () {
        var topPos = $(this).scrollTop();
        if (topPos > 100) {
            $(scrollTop).css("opacity", "1");

        } else {
            $(scrollTop).css("opacity", "0");
        }

    });

    $(scrollTop).click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 800);
        return false;

    });

    //carousel
    $('.last-connection').on('init', function (e, slick) {
        $('#carousel-load').hide();
        $('.last-connection').show();

    }).slick({
        dots: false,
        infinite: true,
        autoplay: true,
        centerMode: true,
        autoplaySpeed: 1000,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                }
            }
        ]
    });

    $('.testimonial-carousel').slick({
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
    });

});


